import { motion } from 'framer-motion';
import Section from '../../../components/Section';
import { Description, FlexContainer } from '../../../styles/pages/Home';
import theme from '../../../styles/theme';
import { fadeInUp } from '../../../variants';

const About: React.FC = () => {

    return (
        <Section backgroundColor={theme.colors.background} id='about'>
            <div className='container'>
                <motion.h1 variants={fadeInUp}>Sobre</motion.h1>
                <motion.span className="sub-title" variants={fadeInUp}> Sobre Mim</motion.span>
                <FlexContainer>
                    <motion.div variants={fadeInUp}>
                        <img src="/img/code.svg" alt="code" />
                    </motion.div>
                    <motion.div variants={fadeInUp}>
                        <Description margin='0 0 0 0'>
                            Sou apaixonado por desafios e tecnologia.
                        </Description>
                        <Description margin='1rem 0 0 0'>
                            Olá sou Patrick,
                            busco sempre aprender mais sobre o mundo da tecnologia,
                            principalmente na área de desenvolvimento web e mobile.
                        </Description>
                        <Description margin='1rem 0 2rem 0'>
                            Atualmente sou estudante do 2° Período de Análise e desenvolvimento de sistemas.
                        </Description>
                        <span className='sub-title'>
                            Email: <span> patrickassuncaodev@gmail.com</span>
                        </span>
                    </motion.div>
                </FlexContainer>
            </div>
        </Section>
    );
}

export default About;